import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../Modal/useModal';
import Button from '../Button';
import NotificationModal from '../NotificationModal/NotificationModal';
import Flag from '../CountryLabel/Flag';

interface Props {
  text?: string;
  title: string;
  country?: string;
}

export default function NotificationWidget({
  text,
  title,
  country,
  children,
}: PropsWithChildren<Props>) {
  const { t, i18n } = useTranslation();
  const { openModal, isModalOpened, closeModal } = useModal();

  return (
    <div>
      <div
        className={`mb-4 grid items-center gap-x-2 rounded-lg border-2 !border-gray-500 bg-white px-4 py-2 ${
          i18n.language === 'en'
            ? 'grid-cols-[2fr,180px]'
            : 'grid-cols-[2fr,215px]'
        }`}
      >
        <div className='flex items-center gap-x-1'>
          {!!country && <Flag country={'FI'} />}
          <span className='font-bold'>{t(text || title)}</span>
        </div>
        <Button size='sm' onClick={openModal} className='Button Button--sm'>
          {t('Show details')}
        </Button>
      </div>
      <NotificationModal
        closeModal={closeModal}
        isModalOpened={isModalOpened}
        title={t(title)}
        country={country}
      >
        <div>{children}</div>
      </NotificationModal>
    </div>
  );
}
